
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type subtitlesRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function subtitlesRT(): TemplateResult<subtitlesRTRootProps> {
    function repeatHierarchicalGroups1(hierarchicalGroups, hierarchicalGroupsIndex) {
        return [hierarchicalGroups(function () {
                return this.term.startsWith('Go-Back-From') ? _createElement('div', { 'key': '5' }, _createElement('a', {
                    'className': 'cm_vehicle-categories_category-container cm_vehicle-categories_link  cm_vehicle-categories_back-button',
                    'href': this.href,
                    'onClick': e => e.stopPropagation()
                }, _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container cm_vehicle-categories_link' }, _createElement('img', {
                    'className': 'cm_vehicle-categories_category-image',
                    'src': this.getImageOrDefault(this.imageUrl),
                    'alt': 'Back to ' + this.value
                })), _createElement('div', { 'className': 'cm_vehicle-categories_category-title-container cm_vehicle-categories_link' }, _createElement('h5', { 'className': 'cm_vehicle-categories_category-title' }, '\n            Back to ', _createElement('b', {}, this.value))))) : null;
            }, { count: undefined })];
    }
    function repeatHierarchicalGroups2(hierarchicalGroups, hierarchicalGroupsIndex) {
        return [hierarchicalGroups(function () {
                return !this.term.startsWith('Go-Back-From') ? _createElement('div', {
                    'className': 'cm_vehicle-categories_category-wrapper' + (this.isSelected ? ' selected' : ''),
                    'key': '5'
                }, _createElement('a', {
                    'className': 'cm_vehicle-categories_category-container cm_vehicle-categories_link',
                    'href': this.href
                }, _createElement('input', {
                    'type': 'checkbox',
                    'className': 'cm_vehicle-categories_category-checkbox',
                    'checked': this.isSelected,
                    'readOnly': true,
                    'aria-label': 'Filter by ' + this.value
                }), _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container cm_vehicle-categories_link' }, _createElement('img', {
                    'className': 'cm_vehicle-categories_category-image',
                    'src': this.getImageOrDefault(this.imageUrl),
                    'alt': this.value
                })), _createElement('div', { 'className': 'cm_vehicle-categories_category-title-container cm_vehicle-categories_link' }, _createElement('h5', { 'className': 'cm_vehicle-categories_category-title' }, this.value)))) : null;
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-categories cm_vehicle-categories__subcategories cm_vehicle-categories__flat' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-categories_category-wrapper-repeater  cmRepeater_hierarchicalGroups' },
        _map(this.hierarchicalGroups, repeatHierarchicalGroups1.bind(this))
    ]), _createElement.apply(this, [
        'div',
        {
            'className': 'cm_vehicle-categories_category-wrapper-repeater  cmRepeater_hierarchicalGroups',
            'data-cm-scroll-container': this.view === 'carousel'
        },
        _map(this.hierarchicalGroups, repeatHierarchicalGroups2.bind(this))
    ]), this.hierarchicalGroups?.length && this.view === 'carousel' ? [
        _createElement('button', {
            'type': 'button',
            'className': 'cm_vehicle-categories_category-scroll-button cm_vehicle-categories_category-scroll-button_left',
            'onClick': this.scrollLeft,
            'disabled': this.isLeftBorder,
            'data-cm-scroll-left': true,
            'key': '30411'
        }),
        _createElement('button', {
            'type': 'button',
            'className': 'cm_vehicle-categories_category-scroll-button cm_vehicle-categories_category-scroll-button_right',
            'onClick': this.scrollRight,
            'disabled': this.isRightBorder,
            'data-cm-scroll-right': true,
            'key': '30413'
        })
    ] : null);
}
        export const componentNames = []